import jwtDecode from 'jwt-decode';
import httpRequest from '../../helpers/httpRequest';
import { AUTH_URL } from '../../../config';

export default {
  initCurrentUser(dispatch) {
    const data = localStorage.getItem('currentUser');
    const currentUser = data ? JSON.parse(data) : null;
    dispatch({ type: 'AUTH__SET_CURRENT_USER', payload: currentUser });
  },
  login(dispatch, getState, { login, password, client_id, domain_name, authUrl = null }) {
    dispatch({ type: 'AUTH__SEND_AUTHENTICATION' });
    httpRequest('POST', authUrl || AUTH_URL, { login, password, client_id, domain_name })
      .then(res => {
        if (res && res.token) {
          const { token } = res;
          const { name, email, groups, person_id, client_id: clientId, domain_name: customerDomainName, _is_pms_admin } = jwtDecode(token, { complete: true });
          // HACK for old compatibility
          const group = groups && groups[0] ? { name: groups[0] } : null;
          const currentUser = { group, name, email, domain_name: customerDomainName, client_id: clientId, person_id, jwt: token, groups, _is_pms_admin };
          localStorage.setItem('currentUser', JSON.stringify(currentUser));
          dispatch({ type: 'AUTH__AUTHENTICATION_SUCCESSFULL', payload: currentUser });
        } else {
          dispatch({ type: 'AUTH__AUTHENTICATION_FAILED' });
        }
      })
      .catch(err => {
        dispatch({ type: 'AUTH__AUTHENTICATION_FAILED', payload: err });
      });
  },
  logout(dispatch) {
    localStorage.removeItem('currentUser');
    dispatch({ type: 'AUTH__LOGOUT' });
  },
  rememberLocationRequested(dispatch, getState, locationRequested) {
    dispatch({ type: 'AUTH__SET_LOCATION_REQUESTED', payload: locationRequested });
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/authentication/triggers.js